import { Country } from '../../../lib/countries';
import { Subset } from '../../../types/Base.types';
import { CreateAccountStore } from './createAccount.types';

export enum SignUpSteps {
  LOCATION_AND_CNPJ = 'LOCATION_AND_CNPJ',
  STORE = 'STORE',
  USER = 'USER',
}

export type CnpjStatus = 'loading' | 'error' | 'success' | 'unset' | 'cnpjAlreadyExists';

export type SignUpUserMode = 'NEW' | 'EXISTENT';

export type SignUpState = {
  currentStep: SignUpSteps;
  location?: Country;
  cnpj: string;
  store: Subset<CreateAccountStore>;
  cnpjStatus: CnpjStatus;
  errorMessage: string;
  userMode: SignUpUserMode;
};
